export const GET_RECOMMENDATIONS_TEMPLATES_REQUEST = "GET_RECOMMENDATIONS_TEMPLATES_REQUEST";
export const GET_RECOMMENDATIONS_TEMPLATES_SUCCESS = "GET_RECOMMENDATIONS_TEMPLATES_SUCCESS";
export const GET_RECOMMENDATIONS_TEMPLATES_FAILURE = "GET_RECOMMENDATIONS_TEMPLATES_FAILURE";

export const GET_DEFAULT_RECOMMENDATION_TEMPLATE_REQUEST = "GET_DEFAULT_RECOMMENDATION_TEMPLATE_REQUEST";
export const GET_DEFAULT_RECOMMENDATION_TEMPLATE_SUCCESS = "GET_DEFAULT_RECOMMENDATION_TEMPLATE_SUCCESS";
export const GET_DEFAULT_RECOMMENDATION_TEMPLATE_FAILURE = "GET_DEFAULT_RECOMMENDATION_TEMPLATE_FAILURE";

export const GET_RECOMMENDATION_TEMPLATE_BY_ID_REQUEST = "GET_RECOMMENDATION_TEMPLATE_BY_ID_REQUEST";
export const GET_RECOMMENDATION_TEMPLATE_BY_ID_SUCCESS = "GET_RECOMMENDATION_TEMPLATE_BY_ID_SUCCESS";
export const GET_RECOMMENDATION_TEMPLATE_BY_ID_FAILURE = "GET_RECOMMENDATION_TEMPLATE_BY_ID_FAILURE";

export const ADD_RECOMMENDATION_TEMPLATE_DATA_REQUEST = "ADD_RECOMMENDATION_TEMPLATE_DATA_REQUEST";
export const ADD_RECOMMENDATION_TEMPLATE_DATA_SUCCESS = "ADD_RECOMMENDATION_TEMPLATE_DATA_SUCCESS";
export const ADD_RECOMMENDATION_TEMPLATE_DATA_FAILURE = "ADD_RECOMMENDATION_TEMPLATE_DATA_FAILURE";

export const GET_PROJECTS_LIST_REQUEST = "GET_PROJECTS_LIST_REQUEST";
export const GET_PROJECTS_LIST_SUCCESS = "GET_PROJECTS_LIST_SUCCESS";
export const GET_PROJECTS_LIST_FAILURE = "GET_PROJECTS_LIST_FAILURE";

export const UPDATE_RECOMMENDATION_TEMPLATE_DATA_REQUEST = "UPDATE_RECOMMENDATION_TEMPLATE_DATA_REQUEST";
export const UPDATE_RECOMMENDATION_TEMPLATE_DATA_SUCCESS = "UPDATE_RECOMMENDATION_TEMPLATE_DATA_SUCCESS";
export const UPDATE_RECOMMENDATION_TEMPLATE_DATA_FAILURE = "UPDATE_RECOMMENDATION_TEMPLATE_DATA_FAILURE";

export const DELETE_SURVEY_TEMPLATE_REQUEST = "DELETE_SURVEY_TEMPLATE_REQUEST";
export const DELETE_SURVEY_TEMPLATE_SUCCESS = "DELETE_SURVEY_TEMPLATE_SUCCESS";
export const DELETE_SURVEY_TEMPLATE_FAILURE = "DELETE_SURVEY_TEMPLATE_FAILURE";

export const GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_REQUEST = "GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_REQUEST";
export const GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_SUCCESS = "GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_SUCCESS";
export const GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_FAILURE = "GET_RECOMMENDATIONS_TEMPLATES_DROPDOWN_LIST_FAILURE";

export const GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_REQUEST = "GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_REQUEST";
export const GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_SUCCESS = "GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_SUCCESS";
export const GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_FAILURE = "GET_SURVEY_RECOMMENDATION_TEMPLATE_EXPORT_FAILURE";

export const RESET_TEMPLATE_REDUCER = "RESET_TEMPLATE_REDUCER";

export const UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEY_RECOMMENDATION_TEMPLATE_ENTITY_PARAMS_FAILURE";

export const CLEAR_TEMPLATE_ENTITY_PARAMS = "CLEAR_TEMPLATE_ENTITY_PARAMS";

export const RESET_RECOMMENDATION_TEMPLATE = "RESET_RECOMMENDATION_TEMPLATE";

export const ADD_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST = "ADD_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST";
export const ADD_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS = "ADD_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS";
export const ADD_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE = "ADD_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE";

export const UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST = " UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_REQUEST";
export const UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS = " UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_SUCCESS";
export const UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE = " UPDATE_FCA_PROJECT_RECOMMENDATION_DATA_FAILURE";

export const DELETE_FCA_PROJECT_SURVEY_REQUEST = "DELETE_FCA_PROJECT_SURVEY_REQUEST";
export const DELETE_FCA_PROJECT_SURVEY_SUCCESS = "DELETE_FCA_PROJECT_SURVEY_SUCCESS";
export const DELETE_FCA_PROJECT_SURVEY_FAILURE = "DELETE_FCA_PROJECT_SURVEY_FAILURE";

export const GET_FCA_PROJECT_RECOMMENDATIONS_REQUEST = "GET_FCA_PROJECT_RECOMMENDATIONS_REQUEST";
export const GET_FCA_PROJECT_RECOMMENDATIONS_SUCCESS = "GET_FCA_PROJECT_RECOMMENDATIONS_SUCCESS";
export const GET_FCA_PROJECT_RECOMMENDATIONS_FAILURE = "GET_FCA_PROJECT_RECOMMENDATIONS_FAILURE";

export const GET_FCA_PROJECT_RECOMMENDATION_BY_ID_REQUEST = "GET_FCA_PROJECT_RECOMMENDATION_BY_ID_REQUEST";
export const GET_FCA_PROJECT_RECOMMENDATION_BY_ID_SUCCESS = "GET_FCA_PROJECT_RECOMMENDATION_BY_ID_SUCCESS";
export const GET_FCA_PROJECT_RECOMMENDATION_BY_ID_FAILURE = "GET_FCA_PROJECT_RECOMMENDATION_BY_ID_FAILURE";

export const GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_REQUEST = "GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_REQUEST";
export const GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_SUCCESS = "GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_SUCCESS";
export const GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_FAILURE = "GET_COMMON_FILTER_LIST_FOR_FCA_SURVEY_PROJECT_FAILURE";

export const GROUP_FCA_SURVEY_UPDATE_REQUEST = "GROUP_FCA_SURVEY_UPDATE_REQUEST";
export const GROUP_FCA_SURVEY_UPDATE_SUCCESS = "GROUP_FCA_SURVEY_UPDATE_SUCCESS";
export const GROUP_FCA_SURVEY_UPDATE_FAILURE = "GROUP_FCA_SURVEY_UPDATE_FAILURE";

export const GET_FCA_SURVEY_PROJECT_FILTER_REQUEST = "GET_FCA_SURVEY_PROJECT_FILTER_REQUEST";
export const GET_FCA_SURVEY_PROJECT_FILTER_SUCCESS = "GET_FCA_SURVEY_PROJECT_FILTER_SUCCESS";
export const GET_FCA_SURVEY_PROJECT_FILTER_FAILURE = "GET_FCA_SURVEY_PROJECT_FILTER_FAILURE";

export const RESET_GLOBAL_FCA_TABLE_DATA_SUCCESS = "RESET_GLOBAL_FCA_TABLE_DATA_SUCCESS";
export const RESET_GLOBAL_FCA_TABLE_DATA_FAILURE = "RESET_GLOBAL_FCA_TABLE_DATA_FAILURE";

export const recomHierarchyDependecyField = [
    "region_id",
    "site_id",
    "building_id",
    "main_building_type_id",
    "addition_id",
    "floor",
    "trade_id",
    "system_id",
    "sub_system_id",
    "installed_year",
    "service_life",
    "usefull_life_remaining",
    "assets.installed_year",
    "assets.current_age",
    "assets.service_life",
    "assets.end_of_service_life",
    "assets.usefull_life_remaining",
    "buildings.description",
    "main_building_type_id"
];
export const RECOM_DEPENDENCY_FIELDS = {
    region_id: ["site_id", "building_id", "floor", "addition_id", "buildings.description"],
    site_id: ["building_id", "floor", "addition_id", "buildings.description"],
    building_id: ["floor", "addition_id"],
    trade_id: ["system_id", "sub_system_id"],
    system_id: ["sub_system_id"]
};

export const MOBILE_RECOM_STATIC_FIELDS = [
    "region_id",
    "site_id",
    "building_id",
    "main_building_type_id",
    "addition_id",
    "floor",
    "room",
    "description",
    "recommendation_type",
    "trade_id",
    "system_id",
    "sub_system_id",
    "notes",
    "criticality_id",
    "asset_condition_id",
    "category_id",
    "recommendation_capital_type_id",
    "installed_year",
    "service_life",
    "usefull_life_remaining",
    "crv",
    "department_id",
    "initiative_id",
    "funding_source_id",
    "responsibility_id"
];
